export default function PHP_attributes() {
  return (
    <div>
      <h1>PHP_attributes</h1>
    </div>
  );
}
